import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-219" data-mp="79052462u77a">
      <Header data-id="element-220" data-mp="2aox5yzce6rp" />
      <main className="flex-1" data-id="element-221" data-mp="2b717hs8xpa6">
        <Outlet data-id="element-222" data-mp="27sz8anhvi39" />
      </main>
      <Footer data-id="element-223" data-mp="gz1vv3pte3pw" />
    </div>;
}